import { render, staticRenderFns } from "./StatReportListItemName.vue?vue&type=template&id=cbea308a"
import script from "./StatReportListItemName.vue?vue&type=script&lang=js"
export * from "./StatReportListItemName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports